import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { Report, ReportService } from './storage-api/report.service';

export interface FieldStatistics {
  type: string;
  cardinality: number;
  missing: number;
  mostCommon?: { [name: string]: number }[];
  avg?: number;
  count?: number;
  min?: number;
  max?: number;
  sum?: number;
}

export interface FieldStatisticsPayload {
  custom: {
    [field: string]: FieldStatistics;
  };
  standard: {
    [field: string]: FieldStatistics;
  };
  mustExist?: string;
}

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class FieldStatisticsService {
  constructor(private reportService: ReportService) {}

  public async getStatsForCollection(
    projectId: string,
    collectionId: string,
    analysisGroupId: string,
    standardFields = '*',
    customFields = '*',
    mustExist?: string,
    query = '',
    timezone?: string
  ): Promise<FieldStatisticsPayload> {
    return new Promise((resolve, reject) => {
      this.reportService
        .getReport(
          collectionId,
          analysisGroupId,
          'fieldStatistics',
          {
            standardFields,
            customFields,
            mustExist,
            timezone,
          },
          'json',
          query,
          '',
          '',
          projectId
        )
        .then((res: Report) => {
          const payload = res.items as FieldStatisticsPayload;
          payload.mustExist = mustExist;
          resolve(payload);
        })
        .catch((reason) => reject(reason));
    });
  }
}
